import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuthPage } from "../../customHooks/AuthPage/useAuthPage";

export default function AuthPage() {
  const location = useLocation(); 
  const { handleAuthFlow } = useAuthPage();

  useEffect(() => {
    if (location) {
      handleAuthFlow();
    }
  }, [location]);

  return <div className=""></div>;
}
